import { createSelector } from 'reselect'
import { isMoveActionAvailable } from '../../utils/vault/vault-helpers'

const getVaultSelectedFoldersList = state => state.vault.selectedFolders
const getVaultSelectedItemsList = state => state.vault.selectedItems
const getVaultItemsList = state => state.vault.itemsList
const getVaultUserId = state => state.vault.userID
const getVaultCaseId = state => state.vault.caseID
const getVaultIsMoving = state => state.vault.isMoving
const getVaultIsCoping = state => state.vault.isCoping
const getVaultSharedById = state => state.vault.sharedBy

export const getVaultCaseFolder = createSelector(
  [getVaultItemsList, getVaultUserId, getVaultCaseId, getVaultSelectedFoldersList],
  (itemsList, userID, caseID, selectedFolders) => {
    // When there are duplicate clients, use uuid from selectedFolders to find exact folder
    let userFolder = null
    if (selectedFolders.length > 0 && selectedFolders[0]) {
      // Use uuid to find exact folder - this is the correct way when duplicates exist
      userFolder = itemsList.find(data => data.uuid === selectedFolders[0].uuid)
    }
    if (!userFolder && userID) {
      // Fallback to relatedID search (may find wrong folder if duplicates exist)
      userFolder = itemsList.find(data => data.relatedID === userID)
    }
    return userFolder && userFolder.children && userFolder.children.find(data => data.relatedID === caseID)
  }
)

export const getVaultCaseChildrenFolder = createSelector(
  [getVaultItemsList, getVaultUserId, getVaultCaseId, getVaultSelectedFoldersList, getVaultSharedById],
  (itemsList, userID, caseID, selectedFolders, sharedBy) => {
    // When there are duplicate clients, use uuid from selectedFolders to find exact folder
    let userFolder = null
    //console.log(userID, itemsList, sharedBy)
    if (selectedFolders.length > 0 && selectedFolders[0]) {
      userFolder = itemsList.find(data => data.uuid === selectedFolders[0].uuid)
    }
    if (!userFolder && userID) {
      if (sharedBy) {
        userFolder = itemsList.find(data => data.relatedID === userID && data.sharedBy === sharedBy)
      } else {
        userFolder = itemsList.find(data => data.relatedID === userID && !sharedBy)
      }
    }
    const caseFolder = userFolder && userFolder.children && userFolder.children.find(data => data.relatedID === caseID)
    return (caseFolder && caseFolder.children) || []
  }
)

export const getIsMoveActionAvailable = createSelector(
  [getVaultSelectedItemsList, getVaultCaseChildrenFolder],
  (selectedRows, casesFolders) => isMoveActionAvailable(selectedRows, casesFolders)
)

export const getVaultPrimaryFolders = createSelector([getVaultSelectedFoldersList], selectedFolders =>
  selectedFolders.slice(0, 2)
)

export const getIsPrivateFolderSelected = createSelector([getVaultSelectedFoldersList], selectedFolders =>
  selectedFolders.find(folder => folder.isPrivateFolder)
)

export const getIsDisableSelection = createSelector(
  [getVaultIsCoping, getVaultIsMoving],
  (isMoving, isCoping) => isMoving || isCoping
)
